/**
 * AIBriefingPanel — AI intelligence briefing with insights + action items.
 */
import React from 'react';
import { minutesAgo } from '../../squareDashboardUtils';

export default function AIBriefingPanel({ aiResult, aiLoading, lastAiRefresh, refreshAI }) {
  return (
    <div className="ai__section">
      <div className="ai__section-header">
        <div>
          <div className="ai__section-title">
            🧠 AI Intelligence Briefing
            {aiResult?.source && (
              <span className={`ai__source-badge ${aiResult.source === 'openai' ? 'ai__source-badge--gpt' : 'ai__source-badge--rules'}`}>
                {aiResult.source === 'openai' ? '✨ GPT-4o-mini' : '📐 Rule-Based'}
              </span>
            )}
          </div>
          <div className="ai__section-sub">
            {lastAiRefresh ? `Updated ${minutesAgo(lastAiRefresh)}m ago` : 'Not yet fetched'}
          </div>
        </div>
        <button
          className={`ai__refresh-btn ${aiLoading ? 'ai__refresh-btn--loading' : ''}`}
          onClick={refreshAI}
          disabled={aiLoading}
        >
          {aiLoading ? '⟳ Analyzing…' : '↻ Refresh AI'}
        </button>
      </div>

      {aiLoading && !aiResult && (
        <div className="ai__briefing-loading">
          <div className="ai__briefing-spinner" />
          <span>Analyzing sales patterns, weather, and anomalies…</span>
        </div>
      )}

      {aiResult && (
        <>
          {aiResult.briefing && <div className="ai__briefing-text">{aiResult.briefing}</div>}

          {aiResult.insights?.length > 0 && (
            <div className="ai__insights-grid">
              {aiResult.insights.map((ins, i) => (
                <div key={i} className={`ai__insight ai__insight--${ins.type || 'info'}`}>
                  <div className="ai__insight-icon">{ins.icon || 'ℹ️'}</div>
                  <div className="ai__insight-body">
                    <div className="ai__insight-title">{ins.title}</div>
                    <div className="ai__insight-text">{ins.body}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {aiResult.actions?.length > 0 && (
            <div className="ai__actions">
              <div className="ai__actions-title">⚡ Recommended Actions</div>
              {aiResult.actions.sort((a, b) => (a.priority || 9) - (b.priority || 9)).map((act, i) => (
                <div key={i} className="ai__action-row">
                  <span className="ai__action-priority">{act.priority || i + 1}</span>
                  <div className="ai__action-body">
                    <span className="ai__action-text">{act.action}</span>
                    {act.reason && <span className="ai__action-reason">{act.reason}</span>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {!aiLoading && !aiResult && (
        <div className="ai__briefing-empty">
          <span>Click "Refresh AI" to generate your first intelligence briefing</span>
        </div>
      )}
    </div>
  );
}
